import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React, { Component } from 'react';
import './ErrorsAccordian.css';
import EventPublish from './EventPublish';

export default class ErrorsAccordian extends Component {
  constructor() {
    super();
    this.state = {
      showDialog: false
    };
  }

  getProvisioningErrors(
    ipsObligations,
    deliverySystemDataSubscriptions,
    unmodifiableServicesForAvatax,
    unmodifiableServicesForSandbox
  ) {
    const actualProvisionedServicesOfAvatax = new Map();
    deliverySystemDataSubscriptions[0]?.forEach(s =>
      actualProvisionedServicesOfAvatax.set(
        s.subscriptionTypeId + '',
        s.subscriptionDescription
      )
    );

    const actualProvisionedServicesOfSandbox = new Map();
    deliverySystemDataSubscriptions[1]?.forEach(s =>
      actualProvisionedServicesOfSandbox.set(
        s.subscriptionTypeId + '',
        s.subscriptionDescription
      )
    );

    const prescribedProvisionedServicesOfAvatax = new Map();
    const prescribedProvisionedServicesOfSandbox = new Map();

    ipsObligations.map(o => {
      o?.entitlements?.forEach(entitlementObject => {
        if (entitlementObject?.deliverySystem === 'avatax') {
          entitlementObject?.service?.forEach(serviceObj => {
            prescribedProvisionedServicesOfAvatax.set(
              serviceObj['id'],
              serviceObj['name']
            );
          });
        }

        if (entitlementObject?.deliverySystem === 'avataxSandbox') {
          entitlementObject?.service?.forEach(serviceObj => {
            prescribedProvisionedServicesOfSandbox.set(
              serviceObj['id'],
              serviceObj['name']
            );
          });
        }
      });
    });

    let provisioningErrorsOfAvatax = [],
      provisioningErrorsOfSandbox = [],
      deprovisioningErrorsOfAvatax = [],
      deprovisioningErrorsOfSandbox = [],
      unmodifiableServicesOfAvatax = [],
      unmodifiableServicesOfSandbox = [];

    prescribedProvisionedServicesOfAvatax.forEach((serviceName, serviceId) =>
      !actualProvisionedServicesOfAvatax.has(serviceId)
        ? provisioningErrorsOfAvatax.push({ [serviceId]: serviceName })
        : ''
    );
    actualProvisionedServicesOfAvatax.forEach((serviceName, serviceId) =>
      !prescribedProvisionedServicesOfAvatax.has(serviceId) &&
      !unmodifiableServicesForAvatax.some(w => {
        return Object.values(w)[0] === serviceId;
      })
        ? deprovisioningErrorsOfAvatax.push({ [serviceId]: serviceName })
        : ''
    );
    actualProvisionedServicesOfAvatax.forEach((serviceName, serviceId) =>
      unmodifiableServicesForAvatax.some(w => {
        return Object.values(w)[0] === serviceId;
      })
        ? unmodifiableServicesOfAvatax.push({ [serviceId]: serviceName })
        : ''
    );
    prescribedProvisionedServicesOfSandbox.forEach((serviceName, serviceId) =>
      !actualProvisionedServicesOfSandbox.has(serviceId)
        ? provisioningErrorsOfSandbox.push({ [serviceId]: serviceName })
        : ''
    );
    actualProvisionedServicesOfSandbox.forEach((serviceName, serviceId) =>
      !prescribedProvisionedServicesOfSandbox.has(serviceId) &&
      !unmodifiableServicesForSandbox.some(w => {
        return Object.values(w)[0] === serviceId;
      })
        ? deprovisioningErrorsOfSandbox.push({ [serviceId]: serviceName })
        : ''
    );
    actualProvisionedServicesOfSandbox.forEach((serviceName, serviceId) =>
      unmodifiableServicesForSandbox.some(w => {
        return Object.values(w)[0] === serviceId;
      })
        ? unmodifiableServicesOfSandbox.push({ [serviceId]: serviceName })
        : ''
    );
    return {
      provisioningErrorsOfAvatax: provisioningErrorsOfAvatax,
      deprovisioningErrorsOfAvatax: deprovisioningErrorsOfAvatax,
      unmodifiableServicesOfAvatax: unmodifiableServicesOfAvatax,
      provisioningErrorsOfSandbox: provisioningErrorsOfSandbox,
      deprovisioningErrorsOfSandbox: deprovisioningErrorsOfSandbox,
      unmodifiableServicesOfSandbox: unmodifiableServicesOfSandbox
    };
  }

  toggleDialog = () => {
    this.setState({ showDialog: !this.state.showDialog });
  };

  displayErrors(Errors) {
    return (
      <div>
        {Errors.map(err => (
          <span key={Object.values(err)[0]}>
            {Object.values(err)[0]}({Object.keys(err)[0]})&emsp;
          </span>
        ))}
      </div>
    );
  }

  render() {
    const unmodifiableServicesForAvatax =
      this.props?.specialServices?.avatax?.unmodifiableList || [];
    const unmodifiableServicesForSandbox =
      this.props?.specialServices?.avataxSandbox?.unmodifiableList || [];
    const provisioningErrors = this.getProvisioningErrors(
      this.props.ipsObligations,
      this.props.deliverySystemDataSubscriptions,
      unmodifiableServicesForAvatax,
      unmodifiableServicesForSandbox
    );
    const provisioningErrorsOfAvatax =
      provisioningErrors?.provisioningErrorsOfAvatax;
    const deprovisioningErrorsOfAvatax =
      provisioningErrors?.deprovisioningErrorsOfAvatax;
    const unmodifiableServicesOfAvatax =
      provisioningErrors?.unmodifiableServicesOfAvatax;
    const provisioningErrorsOfSandbox =
      provisioningErrors?.provisioningErrorsOfSandbox;
    const deprovisioningErrorsOfSandbox =
      provisioningErrors?.deprovisioningErrorsOfSandbox;
    const unmodifiableServicesOfSandbox =
      provisioningErrors?.unmodifiableServicesOfSandbox;

    return (
      <>
        {Object.keys(provisioningErrors).some(error => {
          return provisioningErrors[error].length !== 0;
        }) && (
          <Accordion
            id="errors_accordian"
            onChange={(_event, expanded) => {
              if (expanded) this.props.getUncachedObligation(true);
            }}
            defaultExpanded={this.props.defaultExpanded}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              id="errors_accordian_summary"
            >
              <div>
                {(provisioningErrorsOfAvatax?.length > 0 ||
                  provisioningErrorsOfSandbox?.length > 0) && (
                  <div className="margin-bottom-xs">
                    Provisioning Failures :{' '}
                    {provisioningErrorsOfAvatax?.length > 0 && (
                      <span className="font-weight_600">Avatax </span>
                    )}
                    {provisioningErrorsOfSandbox?.length > 0 && (
                      <span className="font-weight_600">Sandbox </span>
                    )}
                  </div>
                )}

                {(deprovisioningErrorsOfAvatax?.length > 0 ||
                  deprovisioningErrorsOfSandbox?.length > 0) && (
                  <div>
                    Deprovisioning Failures :{' '}
                    {deprovisioningErrorsOfAvatax?.length > 0 && (
                      <span className="font-weight_600">Avatax </span>
                    )}
                    {deprovisioningErrorsOfSandbox?.length > 0 && (
                      <span className="font-weight_600">Sandbox </span>
                    )}
                  </div>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <s-row>
                <s-col span="10">
                  <table className="margin-all-sm" id="errors_table">
                    <tbody>
                      <tr>
                        <th></th>
                        <th>Provisioning</th>
                        <th>Deprovisioning</th>
                      </tr>

                      {(provisioningErrorsOfAvatax?.length > 0 ||
                        deprovisioningErrorsOfAvatax?.length > 0) && (
                        <tr>
                          <th>Avatax</th>
                          <td>
                            {provisioningErrorsOfAvatax?.length > 0
                              ? this.displayErrors(provisioningErrorsOfAvatax)
                              : 'NA'}
                          </td>
                          <td>
                            {deprovisioningErrorsOfAvatax?.length > 0
                              ? this.displayErrors(deprovisioningErrorsOfAvatax)
                              : 'NA'}
                          </td>
                        </tr>
                      )}

                      {(provisioningErrorsOfSandbox?.length > 0 ||
                        deprovisioningErrorsOfSandbox?.length > 0) && (
                        <tr>
                          <th>Sandbox</th>
                          <td>
                            {provisioningErrorsOfSandbox?.length > 0
                              ? this.displayErrors(provisioningErrorsOfSandbox)
                              : 'NA'}
                          </td>
                          <td>
                            {deprovisioningErrorsOfSandbox?.length > 0
                              ? this.displayErrors(
                                  deprovisioningErrorsOfSandbox
                                )
                              : 'NA'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </s-col>
                <s-col span="2">
                  {this.props.showEventsProvision && (
                    <button
                      className="dialogButton"
                      onClick={this.toggleDialog}
                    >
                      Fix Failures
                    </button>
                  )}
                </s-col>
              </s-row>

              {[
                ...new Set([
                  ...unmodifiableServicesOfAvatax,
                  ...unmodifiableServicesOfSandbox
                ])
              ].length > 0 && (
                <>
                  <b>Unmodifiable Services : </b>
                  {[
                    ...new Set([
                      ...unmodifiableServicesOfAvatax,
                      ...unmodifiableServicesOfSandbox
                    ])
                  ].map(s => {
                    return (
                      <span key={Object.values(s)[0]}>
                        {Object.values(s)[0]}({Object.keys(s)[0]})
                      </span>
                    );
                  })}
                </>
              )}
            </AccordionDetails>
          </Accordion>
        )}
        <EventPublish
          showDialog={this.state.showDialog}
          toggleDialog={this.toggleDialog}
          crmId={this.props.crmId}
          loadingStateChanger={this.props.loadingStateChanger}
          deprovisioningErrorsOfAvatax={
            deprovisioningErrorsOfAvatax ? deprovisioningErrorsOfAvatax : []
          }
          deprovisioningErrorsOfSandbox={
            deprovisioningErrorsOfSandbox ? deprovisioningErrorsOfSandbox : []
          }
          key={deprovisioningErrorsOfAvatax}
          specialServices={this.props.specialServices}
        />
      </>
    );
  }
}
